import type { $Fetch } from 'ofetch';
import type { IesGateway } from '@/application/port/out/IesGateway';
import type { Ies } from '@/domain/model/Ies';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

interface IesDto {
  id: string;
  razaoSocial: string;
  nomeFantasia: string | null;
  cnpj: string | null;
  codigoEmec: string | null;
}

export class HttpIesGateway implements IesGateway {
  constructor(private readonly client: $Fetch) {}

  async getCurrent(): Promise<Ies> {
    const res = await this.client<ApiResponse<IesDto>>('/api/v1/ies', {
      method: 'GET',
    });
    assertApiSuccess(res);
    return {
      id: res.data.id,
      razaoSocial: res.data.razaoSocial,
      nomeFantasia: res.data.nomeFantasia,
      cnpj: res.data.cnpj,
      codigoEmec: res.data.codigoEmec,
    };
  }
}
